import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';

import ErrorMessage from '../../error_message/ErrorMessage';

import { getMask } from '../../../../utils/masks';
import { month_options } from '../../../../utils/creditCard';
import { detectCardBrand } from '../../../../utils';

class CardInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedYear: '',
      selectedMonth: '',
      currentBrand: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.calculateAvailableYears();
  }

  calculateAvailableYears() {
    const now = new Date().getUTCFullYear();
    const year_options = [];

    for (let i = 0; i < 20; i++) {
      year_options.push(now + i);
    }

    this.year_options = year_options;
  }

  getCurrentBrand() {
    const brand_selected = this.props.brands.find((brand) => brand.selected);
    return brand_selected ? brand_selected.brand_name : null;
  }

  handleChange(e) {
    const field = {
      name: e.target.name,
      value: e.target.value,
    };

    if (field.name === 'number') {
      const detectedBrand = detectCardBrand(field.value);
      if (detectedBrand) {
        const brandIndex = this.props.brands.findIndex((b) => b.brand_name === detectedBrand);
        if (brandIndex !== -1 && !this.props.brands[brandIndex].selected) {
          this.props.selectCreditCardBrand(brandIndex);
        }
      }
    }

    this.props.changeCreditCardAttr(field);
  }

  handlePaste = (e) => {
    const pastedText = e.clipboardData.getData('text');

    if (pastedText.length > 0) {
      const detectedBrand = detectCardBrand(pastedText);
      if (detectedBrand) {
        e.preventDefault();

        const brandIndex = this.props.brands.findIndex((b) => b.brand_name === detectedBrand);
        if (brandIndex !== -1 && !this.props.brands[brandIndex].selected) {
          this.props.selectCreditCardBrand(brandIndex);
        }

        this.props.changeCreditCardAttr({
          name: 'number',
          value: pastedText,
        });
      }
    }
  };

  getCachedMask = () => {
    const current_brand = this.getCurrentBrand();
    return getMask(current_brand).mask;
  };

  render() {
    const brand_selected = this.props.brands.map((brand, i) => {
      if (brand.selected) {
        return brand.brand_name;
      }
      return '';
    });

    const creditCardErrors = this.props.errors;

    return (
      <div className="a-form desktop">
        <h4>Dados do cartão</h4>
        <form>
          <div className="input-form1">
            <MaskedInput
              guide={false}
              name="number"
              id="cc-number"
              inputMode="numeric"
              onChange={this.handleChange}
              onPaste={this.handlePaste}
              placeholder="Número do cartão"
              value={this.props.creditCard.number}
              mask={this.getCachedMask()}
              className={`${creditCardErrors.number ? 'with-error' : ''}`}
              onBlur={(e) => {
                this.props.validatorHandlerBlur(e.target.value, 'creditcard_number');
                this.forceUpdate();
              }}
            />
            <ErrorMessage anchor={`number`} field1="creditCard" field2="number" />
          </div>
          <div className="input-form1 row">
            <div>
              <input
                type="text"
                name="holder_name"
                id="cc-holder-name"
                placeholder="Nome do titular"
                onChange={this.handleChange}
                className={`${creditCardErrors.holder_name ? 'with-error' : ''}`}
                value={this.props.creditCard.holder_name}
                onBlur={(e) => {
                  this.props.validatorHandlerBlur(e.target.value, 'creditcard_holdername');
                  this.forceUpdate();
                }}
              />
              <ErrorMessage anchor={`number`} field1="creditCard" field2="holder_name" />
            </div>

            <div>
              <MaskedInput
                guide={true}
                name="holder_cpf"
                type="tel"
                placeholder="CPF"
                value={this.props.creditCard.holder_cpf}
                mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                id="cc-holder-cpf"
                onChange={this.handleChange}
                className={`${creditCardErrors.holder_cpf ? 'with-error' : ''}`}
                onBlur={(e) => {
                  this.props.validatorHandlerBlur(e.target.value, 'creditcard_holdercpf');
                  this.forceUpdate();
                }}
              />
              <ErrorMessage anchor={`number`} field1="creditCard" field2="holder_cpf" />
            </div>
          </div>

          <div className="input-form1 row">
            <div className="input-select">
              <select
                name="expiry_month"
                id="cc-expiry-month"
                onChange={this.handleChange}
                className={`mes ${creditCardErrors.expiry_month ? 'with-error' : ''}`}
                onBlur={(e) => {
                  this.props.validatorHandlerBlur(e.target.value, 'creditcard_month');
                }}
                value={this.props.creditCard.expiry_month || ''}
              >
                <option value="" disabled hidden>
                  Mês
                </option>
                {month_options.map((month, i) => (
                  <option value={month.value} key={i}>
                    {month.name}
                  </option>
                ))}
              </select>
              <ErrorMessage anchor={`number`} field1="creditCard" field2="expiry_month" />
            </div>

            <div className="input-select">
              <select
                name="expiry_year"
                id="cc-expiry-year"
                onChange={this.handleChange}
                className={`ano ${creditCardErrors.expiry_year ? 'with-error' : ''}`}
                onBlur={(e) => {
                  this.props.validatorHandlerBlur(e.target.value, 'creditcard_year');
                }}
                value={this.props.creditCard.expiry_year || ''}
              >
                <option value="" disabled hidden>
                  Ano
                </option>
                {this.year_options.map((year, i) => (
                  <option value={year} key={i}>
                    {year}
                  </option>
                ))}
              </select>
              <ErrorMessage anchor={`number`} field1="creditCard" field2="expiry_year" />
            </div>
          </div>
          <div className="input-form1 row">
            <div>
              <MaskedInput
                type="text"
                name="cvv"
                guide={false}
                inputMode="numeric"
                mask={[/\d/, /\d/, /\d/, /\d/]}
                id="cc-verfication-code"
                onChange={this.handleChange}
                value={this.props.creditCard.cvv}
                placeholder="CVV"
                className={`${creditCardErrors.cvv ? 'with-error' : ''}`}
                onBlur={(e) => {
                  this.props.validatorHandlerBlur(e.target.value, 'creditcard_cvv');
                  this.forceUpdate();
                }}
              />
              <ErrorMessage anchor={`number`} field1="creditCard" field2="cvv" />
            </div>

            <div className="cvv-row">
              <div className="cols image-card">
                <img
                  src={brand_selected[0] === 'amex' ? '/assets/images/cvv-icon-2.svg' : '/assets/images/cvv-icon.svg'}
                  alt="cvv-card"
                  className="img-brand"
                />
              </div>
              <div className="cols instruction">
                <span className="text-credit-card">
                  {brand_selected[0] === 'amex' ? '4' : '3'} digitos <br />
                  atrás do <br />
                  cartão.
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default CardInfo;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/CreditCard/CardInfo.jsx